import { Navigate, useLocation } from "@solidjs/router";
import { Show } from "solid-js";
import type { JSX } from "solid-js";
import { useAuth } from "./AuthProvider";

export function ProtectedRoute(props: { children: JSX.Element }) {
  const auth = useAuth();
  const location = useLocation();

  return (
    <Show
      when={!auth.loading()}
      fallback={
        <div class="min-h-screen flex items-center justify-center text-[var(--fg-muted)] text-sm">
          Chargement…
        </div>
      }
    >
      <Show
        when={auth.session()}
        fallback={<Navigate href={`/login?next=${encodeURIComponent(location.pathname)}`} />}
      >
        {props.children}
      </Show>
    </Show>
  );
}
